// Familles du menu (refonte 10/2026) : les entrées existantes sont seulement RANGÉES par famille,
// aucune n'est retirée — une entrée non listée tombe dans « Autres ». Clé = chemin de la route.
export const FAMILIES = [
  { header: "Pilotage", paths: ["/", "/dashboard", "/detailed-reporting", "/sales-trends", "/price-benchmarks", "/experiments"] },
  { header: "Catalogue", paths: ["/products", "/category", "/declinaison", "/importers", "/product-rating", "/products-launching", "/products-sponsoring"] },
  { header: "Marchands & codes", paths: ["/merchands", "/vouchers", "/friends-referred", "/affiliate", "/ambassador", "/physical-shop", "/merchant-place", "/partner-reports", "/display-spaces"] },
  { header: "Site & contenus", paths: ["/appearance", "/advertising", "/landing-pages", "/shoe-rotation-widgets", "/podcasts", "/newsletter", "/notifications", "/dynamic-links", "/qr-codes", "/studio", "/whatsapp"] },
  { header: "Communauté", paths: ["/clients", "/strava-athletes", "/challenges", "/challenge-shop", "/physical-events", "/event-captures", "/games", "/wheel-spin", "/rewards", "/attendee-rewards", "/coins", "/forecasts", "/races", "/favorites-users"] },
  { header: "Système", paths: ["/security", "/users"] },
];

export const familyOf = (route) => {
  const i = FAMILIES.findIndex((f) => f.paths.includes(route.path) || (route.path === "/" && f.paths.includes("/dashboard")));
  return i === -1 ? FAMILIES.length : i;
};


// Page affichée : titre (nom de la sous-page ou de la section) et famille, d'après le menu.
export const pageInfo = (routes, pathname) => {
  for (const r of routes) {
    if (r.children) {
      const c = r.children.find((x) => x.path === pathname);
      if (c) return { title: c.name, section: r.name, family: FAMILIES[familyOf(r)] ? FAMILIES[familyOf(r)].header : "" };
    }
    if (r.path === pathname && !r.children) {
      return { title: r.name, section: "", family: FAMILIES[familyOf(r)] ? FAMILIES[familyOf(r)].header : "" };
    }
  }
  return null;
};
